<template>
  <v-layout>
    <v-flex>
      <v-combobox
        v-model="selectedSellers"
        chips
        clearable
        deletable-chips
        :disabled="!sellersWithDisplayableText.length"
        hide-details
        item-text="displayableText"
        item-value="id"
        :items="sellersWithDisplayableText"
        label="Filtrar por seller"
        :loading="loadingSellersWithPredictions"
        multiple
        no-data-text="Al parecer no pudimos cargar los sellers"
        open-on-clear
        prepend-icon="store"
        small-chips
      >
        <!-- Customize the items in the selection list -->
        <template #item="{ item }">
          <span>{{ item.name }} ({{ item.id }})</span>
          <v-spacer />
          <span v-if="item.numItemsWithPredictions">{{ item.numItemsWithPredictions }} QMIs</span>
        </template>
      </v-combobox>
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapMutations, mapState } = createNamespacedHelpers(
  "classifier"
);

export default {
  computed: {
    ...mapState([
      "currentClassification",
      "getValidatedItems",
      "loadingSellersWithPredictions",
      "selectedSellersWithPredictions",
      "sellersWithPredictions"
    ]),
    selectedSellers: {
      set(sellers) {
        this.setSelectedSellersWithPredictions(sellers);
      },
      get() {
        return this.selectedSellersWithPredictions;
      }
    },
    /**
     * Add a `displayableText` to the sellers object to provide them to the combobox.
     */
    sellersWithDisplayableText() {
      return this.sellersWithPredictions.map(seller => ({
        ...seller,
        displayableText: `${seller.name} (${seller.id})`
      }));
    }
  },
  methods: {
    ...mapActions(["getSellersWithPredictions"]),
    ...mapMutations(["setSelectedSellersWithPredictions"]),
    /**
     * Get the sellers with predictions only if we have a current classification and the app
     * is not already getting the sellers.
     */
    getSellers() {
      if (this.currentClassification && !this.loadingSellersWithPredictions) {
        this.getSellersWithPredictions();
      }
    }
  },
  /**
   * Get the sellers for the combobox on the creation of the component.
   */
  created() {
    this.getSellers();
  },
  watch: {
    /**
     * Change the sellers if the current classification changes.
     */
    currentClassification() {
      this.getSellers();
    },
    /**
     * Get again the sellers when we set the flag to get validated items.
     */
    getValidatedItems() {
      this.getSellers();
    }
  }
};
</script>